import { toCamelCase } from "@helpers/general";
import React from "react";
import { useTranslation } from "react-i18next";

const ENTER_KEY = "Enter";
const SPACE_KEY = " ";
const DEFAULT_SWATCH_TEST_ID = "design-color-picker-swatch";

type PropsType = {
    title?: string;
    color: string;
    testId?: string;
    handleShowColorPickerOnClickEvent: () => void;
};

export function InputGroupWrapper({
    title,
    color,
    testId,
    handleShowColorPickerOnClickEvent,
}: PropsType): JSX.Element {
    const { t } = useTranslation();

    const handleSwatchKeyDown = React.useCallback(
        (e: React.KeyboardEvent<HTMLDivElement>) => {
            if (e.key === ENTER_KEY || e.key === SPACE_KEY) {
                e.preventDefault();
                handleShowColorPickerOnClickEvent();
            }
        },
        [handleShowColorPickerOnClickEvent]
    );

    return (
        <div className="input-group">
            <input
                type="text"
                className={`form-control border ksk_inp_${
                    title !== undefined ? toCamelCase(title) : ""
                }`}
                aria-label={title ?? t("Color")}
                value={color}
                readOnly
            />
            <div className="input-group-prepend border rounded">
                <div
                    className="input-group-text rounded-right"
                    id="btnGroupAddon"
                    data-testid={testId ?? DEFAULT_SWATCH_TEST_ID}
                    role="button"
                    tabIndex={0}
                    aria-haspopup="dialog"
                    aria-label={
                        title
                            ? `${title} ${t("color swatch")}`
                            : t("Open color picker")
                    }
                    onClick={handleShowColorPickerOnClickEvent}
                    onKeyDown={handleSwatchKeyDown}
                    style={{
                        backgroundColor: color,
                        cursor: "pointer",
                        width: "40px",
                        border: "none",
                    }}
                />
            </div>
        </div>
    );
}
